import request from '@/utils/request';

// 分页获取资产
export function getAssetPage(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/page',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资产失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 根据ID获取资产
export function getAssetById(id) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/get/${id}`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资产失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 保存资产
export function getAssetSave(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/save',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '保存资产失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 更新资产
export function getAssetUpdate(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/update',
			method: 'put',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '更新资产失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 更新资产
export function getAssetStatistics(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/statistics',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资产统计失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 查询资产列表，最多返回100条数据
export function getAssetList(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/list',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '查询资产列表失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 分页获取折旧列表
export function getDepreciationPage(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciationPage',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取折旧列表失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 新增计提记录
export function saveDepreciationRecord(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciation/record/save',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '新增计提记录失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 设置资产折旧参数
export function setAssetDepreciationParam(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciation/setParam',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '设置折旧参数失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 停止资产折旧
export function stopAssetDepreciation(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciation/stop',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '停止资产折旧失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 批量设置资产折旧参数
export function batchSetDepreciationParam(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciation/batchSetParam',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '批量设置折旧参数失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 一键计提（当月）
export function oneClickDepreciation(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciation/record/oneClickDepreciation',
			method: 'post',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '一键计提失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取折旧统计数据
export function getDepreciationStatistics(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/depreciation/statistics',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取折旧统计数据失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 导出资产列表
export function exportAssetList(params) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/export`,
			method: 'get',
			params,
			responseType: 'blob',
		})
			.then(response => {
				resolve(response);
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 下载资产导入模板
export function downloadImportTemplate() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/import/template',
			method: 'get',
			responseType: 'blob',
		})
			.then(response => {
				resolve(response);
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 批量导入资产
export function importAsset(file) {
	const formData = new FormData();
	formData.append('file', file);
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/import',
			method: 'post',
			data: formData,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '导入失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 项目资产概览统计（首页 ledger-cards）
export function getProjectStatistics(communityId) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/projectStatistics',
			method: 'get',
			params: { communityId },
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data); // ProjectAssetStatisticsVO
				} else {
					reject(new Error(res.msg || '获取项目资产统计失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

export function getWarningReminder(communityId) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/warningReminder',
			method: 'get',
			params: { communityId },
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取预警提醒失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}